export const RESPONSIBLE_GAMBLING_VIEW = {
    WINDOW: 0,
    IFRAME: 1,
    REDIRECT: 2
};
